import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4515e4d9&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4515e4d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4515e4d9')) {
      api.createRecord('4515e4d9', component.options)
    } else {
      api.reload('4515e4d9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4515e4d9&scoped=true&", function () {
      api.rerender('4515e4d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceFCLSubscribe/index.vue"
export default component.exports